import { buildApiUrl } from '~/app/lib/api-config';
import { z } from 'zod';

export type AssetTypeMetadata = {
  id: string;
  name: string;
};

const assetTypeMetadataSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const assetTypeMetadataListSchema = z.array(assetTypeMetadataSchema);

export const AssetTypeService = {
  async findAll(): Promise<AssetTypeMetadata[]> {
    const response = await fetch(
      buildApiUrl('/api/v1/asset-types/custom-fields'),
      {
        method: 'GET',
        credentials: 'include',
      },
    );

    if (!response.ok) {
      const errorPayload = await response
        .json()
        .catch(() => ({ message: response.statusText }));
      throw new Error(errorPayload.message || 'Failed to fetch asset types');
    }
    return assetTypeMetadataListSchema.parse(await response.json());
  },

  async findById(assetTypeId: string): Promise<AssetTypeMetadata> {
    const normalizedAssetTypeId = assetTypeId.trim();
    if (!normalizedAssetTypeId) {
      throw new Error('Asset type id is required');
    }

    const assetTypes = await this.findAll();
    const assetType = assetTypes.find(
      (item) => item.id === normalizedAssetTypeId,
    );

    if (!assetType) {
      throw new Error('Asset type not found');
    }

    return assetType;
  },
};
